import { BaseService } from "./BaseService";

export interface TwoFactorStatus {
  enabled: boolean;
}

export interface ConfirmEnable2faDto {
  code: string;
}

export interface AccountUrlResponse {
  url: string;
}

class TwoFactorService extends BaseService {
  private basePath = "/two-factor/settings";

  async getStatus(): Promise<TwoFactorStatus> {
    return this.get<TwoFactorStatus>(`${this.basePath}/status`);
  }

  async requestEnable(): Promise<{ success: boolean }> {
    return this.post<{ success: boolean }>(
      `${this.basePath}/request-enable`,
      {},
    );
  }

  async confirmEnable(
    data: ConfirmEnable2faDto,
  ): Promise<{ enabled: boolean }> {
    return this.post<{ enabled: boolean }>(
      `${this.basePath}/confirm-enable`,
      data,
    );
  }

  async disable(): Promise<{ disabled: boolean }> {
    return this.post<{ disabled: boolean }>(`${this.basePath}/disable`, {});
  }

  async getAccountUrl(): Promise<AccountUrlResponse> {
    return this.get<AccountUrlResponse>(`${this.basePath}/account-url`);
  }
}

export const twoFactorService = new TwoFactorService();
